function extra() {
  let top = window.screenTop ? window.screenTop : window.screenY //firefox 兼容
  let left = window.screenLeft ? window.screenLeft : window.screenX //firefox 兼容
  let add = screen.width + screen.height + top + left + document.body.clientHeight + document.body.clientWidth
  if (window.performance !== 'undefined') {
    if (typeof window.performance.now === 'function') {
      add += performance.now()
    }
    if (typeof window.performance.memory !== 'undefined') {
      let memory = performance.memory
      add += memory.totalJSHeapSize + memory.usedJSHeapSize + memory.jsHeapSizeLimit
    }
  }
  return add
}

export default function UUID() {
  let d = new Date().getTime() + extra()
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}
